import { Alerter } from "components/Alert"
import { ConfirmButton } from "components/ConfirmButton"
import { TrashAlt } from "components/Icon"
import { useRouter } from "components/Router"
import { useTranslator } from "components/Translator"
import { useAsync } from "@react-hook/async"

export const AlbumDeleteButton = ({ album, onSuccess, ...props }) => {
  const router = useRouter()

  const [request, deleteAlbum] = useAsync(async () => {
    const url = router.generate("app_user_album_delete", {
      mediaAlbumId: album.id,
    })

    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      })
      const responseData = await response.json()

      if (response.ok) {
        if (responseData.message) {
          Alerter.success(responseData.message)
        }

        if (onSuccess) {
          onSuccess(album)
        }
      } else {
        if (responseData.message) {
          Alerter.error(responseData.message)
        }
      }
    } catch (err) {
      console.error(err)
      Alerter.error(
        translator.trans("AlbumDeleteButton.error", null, "components"),
      )
    }
  })

  const translator = useTranslator()

  return (
    <ConfirmButton
      iconLeft={<TrashAlt className="w-4" />}
      busy={request.status === "loading" || props.busy}
      disabled={request.status === "loading" || props.disabled}
      color="danger"
      confirmTitle={translator.trans(
        "AlbumDeleteButton.confirmTitle",
        null,
        "components",
      )}
      confirmContent={translator.trans(
        "AlbumDeleteButton.confirmContent",
        null,
        "components",
      )}
      confirmLabel={translator.trans(
        "AlbumDeleteButton.confirmLabel",
        null,
        "components",
      )}
      onConfirm={deleteAlbum}
      {...props}
    >
      {translator.trans("AlbumDeleteButton.cta", null, "components")}
    </ConfirmButton>
  )
}
